import { BACKEND_ROUTES } from "../../backendRoutes";
import { PAGINATION } from "../../constants";
import useSWRImmutable from "swr/immutable";

export const useCrops = () =>
    useSWRImmutable(
        `${BACKEND_ROUTES.CROP}?plantScales=true&limit=${PAGINATION.CROP.LIMIT.MAX}`
    );
